import React from 'react';
import OmniTabs from '../OmniTabs/OmniTabs';


const HorizontalTabs = props => {
    return <OmniTabs tabDirection={'horizontal'} {...props}/>
}




export default HorizontalTabs;